import React from 'react';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import { wrapEventHandler } from '../../../utils/handlers';

export default function FavoriteButton({ isFavorite, handleFavoriteClick, onWhiteBg, className }) {
  // Don't display if no click handler given
  if (!handleFavoriteClick) {
    return null;
  }

  const classes = ['clickable', styles.favorite];
  if (onWhiteBg) {
    classes.push(styles.onWhiteBg);
  }
  if (isFavorite) {
    classes.push(styles.selected);
  }
  if (className) {
    classes.push(className);
  }
  const title = isFavorite ? StringConstantsMixin.strings.SEARCH.REMOVE_FROM_LIST : StringConstantsMixin.strings.SEARCH.ADD_TO_LIST;
  return (
    <button
      aria-label={title}
      className={classes.join(' ')}
      onClick={wrapEventHandler(handleFavoriteClick)}
      title={title}
      type="button"
      data-test-id={title}
    />
  );
}
